import { useState, useEffect } from "react";
import showErrorToast from "../../components/CustomComponents/toast/toast";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import FormInput from "../../components/CustomComponents/Input/formInput";

function CategoryTypeModel({
  isModalOpen,
  setIsModalOpen,
  onCategorySubmit,
  compID,
  categoryToEdit = null,
}) {
  const [categoryData, setCategoryData] = useState({
    rC_Name: "",
  });

  useEffect(() => {
    if (categoryToEdit) {
      if (Array.isArray(categoryToEdit)) {
        // For bulk edit, use the first category's name as default
        setCategoryData({
          rC_Name: categoryToEdit[0]?.rC_Name || "",
        });
      } else {
        // For single edit, populate with category data
        setCategoryData({
          rC_ID: categoryToEdit.rC_ID,
          rC_Name: categoryToEdit.rC_Name || "",
        });
      }
    } else {
      // For adding new category
      setCategoryData({
        rC_Name: "",
      });
    }
  }, [categoryToEdit]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCategoryData({
      rC_Name: "",
    });
  };

  const handleSubmit = () => {
    try {
      // Validate category name
      if (!categoryData.rC_Name || categoryData.rC_Name.trim().length === 0) {
        showErrorToast("Please provide a valid category name");
        return;
      }

      if (Array.isArray(categoryToEdit)) {
        // Handle bulk edit
        const submitPromises = categoryToEdit.map((cat) => {
          const submitData = {
            rC_ID: cat.rC_ID,
            rC_Name: categoryData.rC_Name,
            rC_SortOrder: 0, // Default value since not editable
            compID,
            updateDateTime: new Date().toISOString(),
          };
          return onCategorySubmit(submitData, true);
        });
        Promise.all(submitPromises).then(() => {
          setIsModalOpen(false);
          setCategoryData({ rC_Name: "" });
        });
      } else {
        // Handle single add/edit
        const submitData = {
          rC_ID: categoryToEdit ? categoryToEdit.rC_ID : 0,
          rC_Name: categoryData.rC_Name,
          rC_SortOrder: 0, // Default value since not editable
          compID,
          updateDateTime: new Date().toISOString(),
        };
        onCategorySubmit(submitData, !!categoryToEdit);
        setIsModalOpen(false);
        setCategoryData({ rC_Name: "" });
      }
    } catch (err) {
      showErrorToast("Something went wrong.");
      // Error silently
    }
  }

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      onSubmit={handleSubmit}
      title={
        categoryToEdit
          ? Array.isArray(categoryToEdit)
            ? "Bulk Update Reporting Categories"
            : "Update Reporting Category"
          : "Add Reporting Category"
      }
      showButton={true}
      isCentered={true}
      submitButtonText={categoryToEdit ? "Update" : "Add"}
    >
      <div className="row g-3 mb-4">
        <div className="col-md-12">
          <FormInput
            label="Category Name"
            placeHolder="Enter Category Name"
            type="text"
            value={categoryData.rC_Name}
            onchange={(e) =>
              setCategoryData({
                ...categoryData,
                rC_Name: e.target.value,
              })
            }
            required
          />
        </div>
      </div>
    </CustomModal>
  );
}

export default CategoryTypeModel;